(() => {
  const messages = ["Australian Made", "Camping & 4WD Bags"];
  let intervalId = null;
  let originalTitle = null;
  let index = 0;

  const restore = () => {
    if (intervalId !== null) {
      clearInterval(intervalId);
      intervalId = null;
    }
    if (originalTitle !== null) {
      document.title = originalTitle;
      originalTitle = null;
    }
    index = 0;
  };

  const start = () => {
    if (intervalId !== null) return;
    originalTitle = document.title;
    const changeTitle = () => {
      document.title = messages[index];
      index = (index + 1) % messages.length;
    };
    changeTitle();
    intervalId = window.setInterval(changeTitle, 1000);
  };

  const update = () => {
    if (document.visibilityState === "hidden") start();
    else restore();
  };

  document.addEventListener("visibilitychange", update);
  update();
})();
